@if (
  {
    left: (activity.startDatetime | ganttStartingPixel | async),
    right:
      ([activity.startDatetime, activity.endDatetime]
      | ganttEndingPixel
      | async),
    isMoveMode: dragAndDropModeService.isMoveMode$ | async,
  };
  as activityData
) {
  @let hasServiceUpdatePermissions =
    can(RoleAction.Update, RolePermissionSubject.Service);
  @if (activity && containerWidthPxSignal()) {
    <div
      wilsonActivityDragHandler
      class="activity-wrapper"
      [style.width.px]="activityWidth()"
      [style.left.px]="adjustedLeftPositionSignal()"
      [style.height.px]="ACTIVITY_BODY_HEIGHT_PX"
      [ngClass]="
        activity.activityCategory?.isProductiveTime
          ? activity.serviceId
            ? 'service-activity'
            : 'shift-activity'
          : 'unproductive-activity'
      "
      [class.filtered]="activity.id === filteredActivityId && isFiltered"
      nz-tooltip
      [nzTooltipTitle]="isTooltipVisible() ? tooltipInformation : ''"
      [nzTooltipColor]="'#fff'"
      [nzTooltipMouseEnterDelay]="0.3"
      nzTooltipPlacement="top"
      [nzTooltipOverlayStyle]="{ 'max-width': '450px', 'min-width': '250px' }"
      (mouseover)="stopEventFromBubbling($event)"
      [class.cursor-grab]="isCursorGrab"
      [class.cursor-ew-resize]="isCursorGrab && activityData.isMoveMode"
      [class.cursor-not-allowed]="!isDraggable"
      [draggable]="isDraggable"
      [isActivityDraggable]="isDraggable && !!hasServiceUpdatePermissions"
      [hasServiceUpdatePermissions]="!!hasServiceUpdatePermissions"
      [activity]="activity"
      [userId]="userId"
      [leftPx]="activityData.left"
      [rightPx]="activityData.right"
      (isTooltipVisible)="isTooltipVisible.set($event)"
      (isFiltered)="isFiltered = $event"
      (dragstart)="
        setPreviewForMoveMode(
          $event,
          activityData.isMoveMode,
          dragImage,
          !!hasServiceUpdatePermissions
        )
      "
      [attr.data-test-id]="
        'wilson-timeline-auto-size-activity-card:activity-wrapper' +
        activity.name
      "
    >
      <wilson-activity-card-content
        [activity]="activity"
        [calculatedActivityWidth]="activityWidth()"
        [activityEndTimeDifference]="activityEndTimeDifference"
        [activityEndTimeType]="activityEndTimeType"
        [hasMismatchedActivityLocations]="
          isActivityStartLocationMismatch || isActivityEndLocationMismatch
        "
      ></wilson-activity-card-content>
    </div>
  }
}
<ng-template #tooltipInformation>
  <wilson-timeline-activity-tooltip
    [activity]="activity"
    [accurateActivityStartDateTime]="accurateActivityStartDateTime"
    [accurateActivityEndDateTime]="accurateActivityEndDateTime"
    [activityStartTimeDifference]="activityStartTimeDifference"
    [activityEndTimeDifference]="activityEndTimeDifference"
    [activityStartTimeType]="activityStartTimeType"
    [activityEndTimeType]="activityEndTimeType"
    [isActivityStartLocationMismatch]="isActivityStartLocationMismatch"
    [isActivityEndLocationMismatch]="isActivityEndLocationMismatch"
  >
  </wilson-timeline-activity-tooltip>
</ng-template>

<div id="move-activity" class="move-preview" #dragImage></div>
